const angular = require('angular');

/**
 * @param {Array} [additionalModules]
 *
 * @return {angular.Module}
 */
const createAngularApp = (additionalModules = []) => {
    /**
     * This is the list of AngularJS plugins/modules to use.
     *
     * Here we have a problem with some third party Angular modules.
     * Ideally this would be an array that looks like:
     * [
     *     require('angular-route'),
     *     require('angular-resource'),
     *     // etc.
     * ]
     * but some of these modules are really old and don't expose themselves that way.
     *
     * For the time being we have Grunt generate the 'angular-vendor.js' file that just sticks those all together like
     * old times and add them by name like we've always done.
     * One by one we'll replace each of these strings with a require('package-name') and remove that module from
     * angular-vendors.js
     *
     * @type {string[]}
     */
    let modules = [
        'ngRoute',
        'ngResource',
        'ngSanitize',
        'ui.bootstrap',
        'pasvaz.bindonce',
        'templates-main',
    ];

    if (additionalModules && additionalModules.length > 0) {
        Array.prototype.push.apply(modules, additionalModules);
    }

    /**
     * Instantiate Angular.
     */
    const app = angular.module('dtProPoint', modules);

    /**
     * Application-wide default configuration for UI Bootstrap date picker
     *
     * TODO: Only init on the apps using Angular for UI.
     */
    app.constant('datepickerConfig', {
        dayFormat: 'dd',
        monthFormat: 'MMMM',
        yearFormat: 'yyyy',
        dayHeaderFormat: 'EEE',
        dayTitleFormat: 'MMMM yyyy',
        monthTitleFormat: 'yyyy',
        showWeeks: false,
        startingDay: 0,
        yearRange: 20,
        minDate: null,
        maxDate: null,
    });

    return app;
};

module.exports = createAngularApp;
